
       <div class="card card-info" [ngClass]="{'dark-bg' : isDark }">
        <div class="card-header">Guest Purchase List</div> 
         <div class="row mt-2 ml-3">
            <div class="input-group col-md-8 ">         
                   
             <mat-form-field class="example-form-field">
               <mat-label [ngClass]="{'dark-bg' : isDark }">Search</mat-label>  
               <span matPrefix><i class="fas fa-search">&nbsp; &nbsp;</i></span>                    
               <input matInput type="text" [(ngModel)]="searchKey" autocomplete="off" (keyup)="applyFilter()">
               <span class="input-group-append" matSuffix>
                 <button class="btn  border-0" type="button">
                     <i *ngIf="searchKey" (click)="onSearchClear()" class="fa fa-close" [ngClass]="{'dark-bg' : isDark }"></i>
                 </button>
               </span> 
             </mat-form-field>
   
           </div>
           <div class="col-md-4">
             <button (click)="newButtonClick()" class="btn btn-light float-right mr-4"><i class="fa fa-plus p-1"></i>New</button>
           </div>      
         </div>
         <form class="form-horizontal">
         <fieldset>
         <div class="card-body">
   
           <div>
            <table mat-table #outerSort="matSort" [dataSource]="dataSource" multiTemplateDataRows matSort>
                       
               <ng-container matColumnDef="GuestId">
                 <th mat-header-cell *matHeaderCellDef mat-sort-header [ngClass]="{'dark-bg' : isDark }"> GuestId </th>
                 <td mat-cell *matCellDef="let element" [ngClass]="{'dark-bg' : isDark }"> {{element.GuestId}}</td>
               </ng-container>
                        
                       
               <ng-container matColumnDef="GuestName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header [ngClass]="{'dark-bg' : isDark }"> GuestName </th>
                <td mat-cell *matCellDef="let element" [ngClass]="{'dark-bg' : isDark }"> {{element.GuestName}} </td>
               </ng-container>
                      
               <ng-container matColumnDef="TotalAmount">
                <th mat-header-cell *matHeaderCellDef   mat-sort-header  [ngClass]="{'dark-bg' : isDark }"> Total Amount </th>
                <td mat-cell *matCellDef="let element" [ngClass]="{'dark-bg' : isDark }"> {{element.TotalAmount |  number:'1.2-2'}} </td>
               </ng-container>

               <ng-container matColumnDef="Action">
                <th mat-header-cell *matHeaderCellDef [ngClass]="{'dark-bg' : isDark }">Action</th>
                 <td mat-cell *matCellDef="let row" [ngClass]="{'dark-bg' : isDark }">
                  <button class="btn btn-light btn-sm"  *ngIf="!(row==expandedElement)"  (click)="toggleRow(row)" data-toggle="expandTooltip" data-placement="bottom" title="Expand"><i class="fa fa-plus"></i></button>
                  <button class="btn btn-light btn-sm"  *ngIf="(row==expandedElement)" (click)="toggleRow(row)" data-toggle="collapseTooltip" data-placement="bottom" title="collapse"><i class="fa fa-minus"></i></button>
                 </td>
               </ng-container> 

                <!-- Template for details row -->

                <ng-container matColumnDef="expandedDetail">
                  <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
                    <div class="example-element-detail" *ngIf="element.purchaseItems?.data.length" [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                      <div class="inner-table" *ngIf="expandedElement">
                        <!-- <mat-form-field>
                          <input matInput (keyup)="applyFilterChild($event.target.value)" placeholder="Filter">
                        </mat-form-field> -->
                        <table #innerTables mat-table #innerSort="matSort" [dataSource]="element.purchaseItems" matSort>
                          <ng-container matColumnDef="PurchaseDate" class="make-gold">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Purchase Date </th>
                            <td mat-cell *matCellDef="let element"> {{element.PurchaseDate  | date :'y-MM-dd'}} </td>
                          </ng-container>
                          <ng-container matColumnDef="ItemCode" class="make-gold">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> ItemCode </th>
                            <td mat-cell *matCellDef="let element"> {{element.ItemCode}} </td>
                          </ng-container>
                          <ng-container matColumnDef="Description">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Description</th>
                            <td mat-cell *matCellDef="let element"> {{element.Description}} </td>
                          </ng-container>
                          <ng-container matColumnDef="UnitPrice">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>UnitPrice</th>
                            <td mat-cell *matCellDef="let element"> {{element.UnitPrice |  number:'1.2-2'}} </td>
                          </ng-container>
                          <ng-container matColumnDef="Qty">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Qty</th>
                            <td mat-cell *matCellDef="let element"> {{element.Qty}} </td>
                          </ng-container>
                          <ng-container matColumnDef="Amount">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Amount</th>
                            <td mat-cell *matCellDef="let element"> {{element.Amount |  number:'1.2-2'}} </td>
                          </ng-container>

                          <ng-container matColumnDef="Status">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Status</th>
                            <td mat-cell *matCellDef="let element"><span class="badge" [ngClass]="{'badge-warning' : element.Status==='Not Invoiced', 'badge-success' : element.Status==='Invoiced'}" >{{element.Status }}</span></td>
                          </ng-container>

                          <ng-container matColumnDef="CreatedBy">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> CreatedBy</th>
                            <td mat-cell *matCellDef="let element"> {{element.CreatedBy}} </td>
                          </ng-container>

                
                          <ng-container matColumnDef="Action">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Action </th>
                            <td mat-cell *matCellDef="let row">
                              <button class="btn btn-light btn-sm ml-1" (click)="veiwButtonClick(row)" data-toggle="viewTooltip" data-placement="bottom" title="View"><i class="fa fa-file-text"></i></button>
                              <button class="btn btn-light btn-sm ml-1" *ngIf="(row.Status=='Not Invoiced')"  (click)="deleteButtonClick(row.Id)"  data-toggle="deleteTooltip" data-placement="bottom" title="Delete"><i class="far fa-trash-alt"></i></button> 
                           </td>
                          </ng-container>
                          <tr mat-header-row *matHeaderRowDef="innerDisplayedColumns"></tr>
                          <tr mat-row *matRowDef="let row; columns: innerDisplayedColumns;"></tr>
                        </table>
                      </div>
                    </div>
                  </td>
                </ng-container>
   
                <ng-container matColumnDef="loading">
                 <td class="footer-align" mat-footer-cell *matFooterCellDef colspan="6" [ngClass]="{'dark-bg' : isDark }"> Loading data... </td> 
               </ng-container>
   
               <ng-container matColumnDef="noData">
                 <td class="footer-align" mat-footer-cell *matFooterCellDef colspan="6" [ngClass]="{'dark-bg' : isDark }"> No data available in table </td>
               </ng-container> 

  
             
               <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
               <tr mat-row *matRowDef="let element; columns: displayedColumns;" [class.example-element-row]="element.purchaseItems?.data.length" [class.example-expanded-row]="expandedElement === element"></tr>
               <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
               <tr mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{'hide' : dataSource!=null }"></tr>
               <tr mat-footer-row *matFooterRowDef="['noData']" [ngClass]="{'hide' : !(dataSource!=null && dataSource.data.length==0)}"></tr>

              </table>
   
             <mat-paginator [ngClass]="{'dark-bg' : isDark }" [pageSize]="10" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
   
             </div>
   
   
         </div>                                
         <!-- /.card-body -->
       </fieldset>
         </form>
       </div>
     
   <script>
    $(function () {
     $('[data-toggle="expandTooltip"]').tooltip()
    })
    $(function () {
     $('[data-toggle="collapseTooltip"]').tooltip()
    })
   
    $(function () {
     $('[data-toggle="viewTooltip"]').tooltip()
   })
   $(function () {
     $('[data-toggle="deleteTooltip"]').tooltip()
   })
   </script>




